import api from '../../api'

export const saveProj = async (api,proj,addToast,{setShow,setErr,enableReadMode,setResultMsg,isLinkedFromHistory,isNewProject},callBack=null) => {
  let res;
  try {
    res = await api.post(`/projs/${proj.id}`, proj);
    if (!res?.id) {
      throw Error();
    }
    if (proj.attachments.some((v) => !v.id)) {
      const savedAttachments = res.id ? await api.postProjAttachments(`/projs/${proj.id}/uploadAttachments`, proj.attachments) : null;
      if (!savedAttachments?.ok) {
        const error = await savedAttachments.json();
        throw Error(error.error.message);
      }
    }
    addToast.success('Проект успешно сохранен');
    setShow(true);
    setErr(false);
    !!enableReadMode && enableReadMode(isNewProject ? res.id : proj, isNewProject ? res.id : isLinkedFromHistory.current);
    if (!!callBack && !!res) {
      res.id && callBack(res.id);
    }
  } catch (err) {
    setResultMsg(err?.message || 'Не удалось сохранить проект');
    setShow(true);
    setErr(true);
  }
};

export const saveExpertDecision = (addToast, {projIds,year,recommendations,isApproved,protocol,mark,decisionDate,decisionFiles}, projId=0) => {
    return makeExpertDecision({year,decision:recommendations,isApproved,protocol,mark,decisionDate,projIds:JSON.stringify(projIds)},decisionFiles,`/projs/${projId}/results/0/decide`)
        .then(x=>addToastToResponse(addToast.success,!!projId ? 'Проект оценен' : projIds && 'Выбранные проекты оценены',x[0]))
        .catch(x=>addToastToResponse(addToast.error,x,x))
}
export const editExpertDecision = (addToast,{year,recommendations,isApproved,protocol,mark,decisionDate,decisionFiles},projId) => {
    return makeExpertDecision({year,decision:recommendations,isApproved,protocol,mark,decisionDate},decisionFiles,`/projs/${projId}/results/0/editDecision`)
        .then(x=>addToastToResponse(addToast.success,"Решение ЭГ изменено",x))
        .catch(x=>addToastToResponse(addToast.error,x,x))
}

export const closeProject = (addToast,{projIds,closedOn,closeFiles}) => {
    return makeExpertDecision({projIds:JSON.stringify(projIds),closedOn},closeFiles,`/projs/0/close`)
        .then(x=>addToastToResponse(addToast.success,!!projIds.length<=1 ? 'Проект закрыт' : 'Выбранные проекты закрыты',x[0]))
        .catch(x=>addToastToResponse(addToast.error,x,x))
}

export const editCloseDataProject = (addToast,{projId,closedOn,closeFiles}) => {
    return makeExpertDecision({closedOn},closeFiles,`/projs/${projId}/editCloseDecision`)
        .then(x=>addToastToResponse(addToast.success,'Проект закрыт',x))
        .catch(x=>addToastToResponse(addToast.error,x,x))
}



// export const saveNewProj = async (api,proj,addToast,{setShow,setErr,enableReadMode,setResultMsg,isLinkedFromHistory},callback) => {
//     if (!isLinkedFromHistory){
//         let copiedEnableReadMode = ()=> null
//         const result = await saveProj(api,proj,addToast,{setShow,setErr,enableReadMode:null,setResultMsg,isLinkedFromHistory})
//         !!result.id && enableReadMode(result.id)
//         !!result.id && await callback(result.id)
//     }
// };

export const getReportByProjId = (addToast,year,projId) => {
    return api.get(`/projs/${projId}/results?year=${year}`,true)
        .catch(y=>addToast.error(y))
}


const makeExpertDecision = (body,files,url) => {
    const newFiles = files?.filter(el=>!el?.id) ?? null
    const oldFilesIds = files?.filter(el=>el?.id)?.map(file=>file.id) ?? []
    const bodyWithFileIds = {...body,fileIds:JSON.stringify(oldFilesIds)}
    return api.postFormData(url,bodyWithFileIds,newFiles ,{raw:true})
}
const addToastToResponse = (method,text,response) => {
    method.call(null,text)
    if(method.name === 'error'){
        return Promise.reject()
    }
    return response
}

export async function saveMilestones(milestones, projId){
    return await api.post(`/projs/${projId}/milestones`, milestones)
}